<template>
  <div class="container">
    <div class="top_title">顾问回访</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="item schoolItem" style="margin-top: 2.5rem">
        <p class="title"><span></span>选择校区</p>
        <div class="options">
          <span class="school" v-for="school in info.dataList1" :class="{active:school.I_CHECK_FLAG == 'Y'}" @click="clickSchool(school.I_SCHOOL_NO)">
            {{school.I_SCHOOL_NAME}}
            <i style="display: none">{{school.I_SCHOOL_NO}}</i>
          </span>
        </div>
      </div>
      <div class="item classItem">
        <p class="title"><span></span>选择班级</p>
        <div class="options">
          <span class="classes" v-for="item in info.dataList2" :class="{active:item.I_CHECK_FLAG == 'Y'}" @click="clickClass(item.I_CLASS_NO)">
            {{item.I_CLASS_NAME}}
            <i style="display: none">{{item.I_CLASS_NO}}</i>
          </span>
        </div>
        <div class="teacher_info">
          <p>{{info.I_CLASS_DATE_TIME}}</p>
          <p>{{info.I_TEACHER}}</p>
        </div>
      </div>
      <div class="item studentItem">
        <p class="title"><span></span>选择学员</p>
        <div class="options">
          <span class="student" v-for="student in info.dataList3" :class="{active:student.I_CHECK_FLAG == 'Y'}" @click="clickStudent(student.I_STUDENT_NO)">
            {{student.I_STUDENT_NAME}}
            <i style="display: none">{{student.I_STUDENT_NO}}</i>
          </span>
        </div>
      </div>
      <div class="weui-cells item visitRecords">
        <p class="title"><span></span>回访记录(最近3次)</p>
        <div v-for="record in info.dataList4" :key="record.id" @click="clickRecord(record)"
             class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__bd">
            <p>{{record.I_STUDENT_NAME}}</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text" disabled :value="record.I_DATE"/>
          </div>
        </div>
      </div>
      <button class="bottom_btn" @click="addVisit">新增回访</button>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          dataList1: [],
          dataList2: [],
          dataList3: [],
          dataList4: [],
        },
        currentSchoolNo: "", /*当前校区编号*/
        currentClassNo: "", /*当前班级编号*/
        currentStudentNo: "", /*当前学员编号*/
      }
    },
    components: {
      Footer
    },
    created() {
      let H200060Info = this.$route.params.info
      let params;
      if(H200060Info) {
        params = JSON.parse(H200060Info)
      } else {
        params = {
          I_SCHOOL_NO: this.currentSchoolNo,
          I_CLASS_NO: this.currentClassNo,
          I_STUDENT_NO: this.currentStudentNo
        }
      }

      DataRequestFactory.I200050(params).then((response) => {
        this.info = response
      })
    },
    methods: {
      clickSchool(schoolNo) {
        this.currentSchoolNo = schoolNo
        let params = {
          I_SCHOOL_NO: this.currentSchoolNo,
          I_CLASS_NO: "",
          I_STUDENT_NO: ""
        }
        DataRequestFactory.I200050(params).then((response) => {
          this.info = response
        })
      },
      clickClass(classNo) {
        this.currentClassNo = classNo
        let params = {
          I_SCHOOL_NO: this.currentSchoolNo,
          I_CLASS_NO: this.currentClassNo,
          I_STUDENT_NO: ""
        }
        DataRequestFactory.I200050(params).then((response) => {
          this.info = response
        })
      },
      clickStudent(studentNo) {
        this.currentStudentNo = studentNo
        let params = {
          I_SCHOOL_NO: this.currentSchoolNo,
          I_CLASS_NO: this.currentClassNo,
          I_STUDENT_NO: this.currentStudentNo
        }
        DataRequestFactory.I200050(params).then((response) => {
          this.info = response
        })
      },
      clickRecord(record) {
        let H200030Info = {
          I_SCHOOL_NO: record.I_SCHOOL_NO,
          I_CLASS_NO: record.I_CLASS_NO,
          I_STUDENT_NO: record.I_STUDENT_NO,
          I_DATE: record.I_DATE
        }

        this.$router.push({name: "H200060", params: {info: JSON.stringify(H200030Info)}})
      },
      addVisit () {
        let H200030Info = {
          I_SCHOOL_NO: $(".school.active i")[0].textContent,
          I_CLASS_NO: $(".classes.active i")[0].textContent,
          I_STUDENT_NO: $(".student.active i")[0].textContent,
          I_DATE: ""
        }

        this.$router.push({name: "H200060", params: {info: JSON.stringify(H200030Info)}})
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 3.5
      $(".scroll_area").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H200030.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H200050.vue